let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kv4iC")).then(() => parcelRequire('jvegN'));